module.exports = __webpack_public_path__ + "static/media/souha.4d2159e3.webp";